import { BASE_API } from "../Config/Config";

export const fetchsliderimagesapi = async () => {
    try {
        const response = await fetch(
            `${BASE_API}/apis/sliderimages.php`,
            {
                method: "POST",
            }
        );

        const result = await response.json();

        if (
            result.status === true &&
            Array.isArray(result.data)
        ) {
            return result.data;
        } else {
            return [];            
        }
    } catch (err) {
        console.error("Fetch Error:", err);
        return [];
    }
};